import { UnknownProviderError } from '../../errors/unknown-provider-error';

export class UnknownFacebookError extends UnknownProviderError {
	constructor(cause: any) {
		super(cause);
		this.name = 'UnknownFacebookError';
	}
}
